const Index = resolve => require(["../views/zh-CN/index"], resolve);
const searchResult = resolve =>
    require(["../views/zh-CN/searchResult"], resolve);
const usSearchResult = resolve =>
    require(["../views/en-US/searchResult"], resolve);
const zangsSearchResult = resolve =>
    require(["../views/zangs/searchResult"], resolve);
const startPage = resolve => require(["../views/zh-CN/startPage"], resolve);
const ticket = resolve => require(["../views/zh-CN/ticket/ticket"], resolve); // 票务预约、改扩建工程、党务公开
const educationActivity = resolve =>
    require(["../views/zh-CN/educationActivity/educationActivity"], resolve); // 教育活动
const activityList1 = resolve =>
    require(["../views/zh-CN/educationActivity/activityList1"], resolve); // 活动列表
const activityList2 = resolve =>
    require(["../views/zh-CN/educationActivity/activityList2"], resolve); // 活动列表
const activityList3 = resolve =>
    require(["../views/zh-CN/educationActivity/activityList3"], resolve); // 活动列表
const activityList4 = resolve =>
    require(["../views/zh-CN/educationActivity/activityList4"], resolve); // 活动列表
const volunteerHome = resolve =>
    require(["../views/zh-CN/educationActivity/volunteerHome"], resolve); // 志愿者之家
const volunteerMien = resolve =>
    require(["../views/zh-CN/educationActivity/volunteerMien"], resolve); // 志愿者风采
const activityDetail = resolve =>
    require(["../views/zh-CN/educationActivity/activityDetail"], resolve); // 志愿者风采详情
const hdDetail = resolve =>
    require(["../views/zh-CN/educationActivity/hdDetail"], resolve); // 教育活动详情

// 票务
const appointment = resolve =>
    require(["../views/zh-CN/ticket/children/appointment"], resolve); // 票务预约入口
const notice = resolve =>
    require(["../views/zh-CN/ticket/children/children/notice"], resolve); // 预约须知
const chooseDate = resolve =>
    require(["../views/zh-CN/ticket/children/children/chooseDate"], resolve); // 选择预约日期
const personalInfo = resolve =>
    require(["../views/zh-CN/ticket/children/children/personalInfo"], resolve); // 填写个人信息
const confirmOrder = resolve =>
    require(["../views/zh-CN/ticket/children/children/confirmOrder"], resolve); // 确认信息
const complete = resolve =>
    require(["../views/zh-CN/ticket/children/children/complete"], resolve); // 预约完成

// 改扩建工程
const extensionPro = resolve =>
    require(["../views/zh-CN/ticket/children/extensionPro"], resolve);

// 党务政务公开
const government = resolve =>
    require(["../views/zh-CN/ticket/children/government"], resolve);

// 博物馆简介
const brief = resolve => require(["../views/zh-CN/brief/brief"], resolve); // 博物馆简介
// 历史沿革
const historyRecord = resolve =>
    require(["../views/zh-CN/brief/children/historyRecord"], resolve);
// 机构设置
const sectionSet = resolve =>
    require(["../views/zh-CN/brief/children/sectionSet"], resolve);
// 馆长致辞
const curatorSpeech = resolve =>
    require(["../views/zh-CN/brief/children/curatorSpeech"], resolve);
// 大事记
const bigEvents = resolve =>
    require(["../views/zh-CN/brief/children/bigEvents"], resolve);
// 展览展讯
const exhibitionMsg = resolve =>
    require(["../views/zh-CN/exhibitionMsg/exhibitionMsg"], resolve);
// 全景漫游-全部
// const allQuanjing = (resolve) => require(['../views/zh-CN/exhibitionMsg/allQuanjing'], resolve)
const allQuanjing = resolve =>
    require(["../views/zh-CN/exhibitionMsg/allQuanjingNew"], resolve);
// 专题展览-全部
const allZhuanti = resolve =>
    require(["../views/zh-CN/exhibitionMsg/allZhuanti"], resolve);
const exhibitionReview = resolve =>
    require(["../views/zh-CN/exhibitionMsg/exhibitionReview"], resolve);
// 展品详情
const exhibitionDetail = resolve =>
    require(["../views/zh-CN/exhibitionMsg/exhibitionDetail"], resolve);
// 文创产品
const wenChuang = resolve =>
    require(["../views/zh-CN/wenChuang/wenchuang"], resolve); // 文创产品
// 文博快讯
const wenboNews = resolve =>
    require(["../views/zh-CN/wenChuang/children/wenboNews"], resolve); // 文博快讯
// 相关公告
const notices = resolve =>
    require(["../views/zh-CN/wenChuang/children/notices"], resolve); // 相关公告
// 政策法规
const policies = resolve =>
    require(["../views/zh-CN/wenChuang/children/policies"], resolve); // 政策法规
// 快讯公告详情advisoryDetail
const advisoryDetail = resolve =>
    require(["../views/zh-CN/wenChuang/advisoryDetail"], resolve);

// 展品详情
const exhibitsDetail = resolve =>
    require(["../views/zh-CN/gemEnjoy/exhibitsDetail"], resolve);
// 藏品欣赏
const gemEnjoy = resolve =>
    require(["../views/zh-CN/gemEnjoy/gemEnjoy"], resolve);
// 珍品赏析
const enjoy = resolve =>
    require(["../views/zh-CN/gemEnjoy/children/enjoy"], resolve);
// 文物快览
const quickLook = resolve =>
    require(["../views/zh-CN/gemEnjoy/children/quickLook"], resolve);
// 文物征集与捐赠
const collect = resolve =>
    require(["../views/zh-CN/gemEnjoy/children/collect"], resolve);
// 公众征集
const solicitation = resolve =>
    require(["../views/zh-CN/gemEnjoy/solicitation"], resolve);

// 文创产品
const wenchuangProduct = resolve =>
    require(["../views/zh-CN/wenChuangProduct/wenChuangProduct"], resolve);
// 文创产品
const wcProducts = resolve =>
    require(["../views/zh-CN/wenChuangProduct/children/wcProducts"], resolve);
// 文创精品
const wcBoutique = resolve =>
    require(["../views/zh-CN/wenChuangProduct/children/wcBoutique"], resolve);
// 文创动态
const wcDynamic = resolve =>
    require(["../views/zh-CN/wenChuangProduct/children/wcDynamic"], resolve);
// 文创动态详情
const wcdynamicDetail = resolve =>
    require(["../views/zh-CN/wenChuangProduct/wcdynamicDetail"], resolve);

// 首页底部调查问卷、留言板、法律法规、馆长信箱等
const indexBtm = resolve =>
    require(["../views/zh-CN/indexBtm/indexBtm"], resolve);
// 调查问卷
const questionnaire = resolve =>
    require(["../views/zh-CN/indexBtm/children/questionnaire"], resolve);
// 留言板
const messageBoard = resolve =>
    require(["../views/zh-CN/indexBtm/children/messageBoard"], resolve);
// 法律法规
const laws = resolve =>
    require(["../views/zh-CN/indexBtm/children/laws"], resolve);
// 馆长信箱
const mailbox = resolve =>
    require(["../views/zh-CN/indexBtm/children/mailbox"], resolve);

// 学术研究
const academicResearch = resolve =>
    require(["../views/zh-CN/academicResearch/academicResearch"], resolve);
// 学术机构
const academicJigou = resolve =>
    require([
        "../views/zh-CN/academicResearch/children/academicJigou"
    ], resolve);
// 学术期刊
const academicQikan = resolve =>
    require([
        "../views/zh-CN/academicResearch/children/academicQikan"
    ], resolve);
// 学术讲堂
const academicClassroom = resolve =>
    require([
        "../views/zh-CN/academicResearch/children/academicClassroom"
    ], resolve);

// 科技保护
const scienceProtect = resolve =>
    require(["../views/zh-CN/scienceProtect/scienceProtect"], resolve);
// 联合工作站简介
const scienceIntro = resolve =>
    require(["../views/zh-CN/scienceProtect/children/scienceIntro"], resolve);
// 保护修复成果
const scienceAchievement = resolve =>
    require([
        "../views/zh-CN/scienceProtect/children/scienceAchievement"
    ], resolve);
// 科普知识
const scienceKnowledge = resolve =>
    require([
        "../views/zh-CN/scienceProtect/children/scienceKnowledge"
    ], resolve);
// 知识详情knowledgeDetail
const knowledgeDetail = resolve =>
    require(["../views/zh-CN/scienceProtect/knowledgeDetail"], resolve);
/// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////英藏版
const usIndex = resolve => require(["../views/en-US/index"], resolve);
// 首页底部调查问卷、留言板、法律法规、馆长信箱等
const usIndexBtm = resolve =>
    require(["../views/en-US/indexBtm/indexBtm"], resolve);
// 调查问卷
const usQuestionnaire = resolve =>
    require(["../views/en-US/indexBtm/children/questionnaire"], resolve);
// 留言板
const usMessageBoard = resolve =>
    require(["../views/en-US/indexBtm/children/messageBoard"], resolve);
// 法律法规
const usLaws = resolve =>
    require(["../views/en-US/indexBtm/children/laws"], resolve);
// 馆长信箱
const usMailbox = resolve =>
    require(["../views/en-US/indexBtm/children/mailbox"], resolve);
// 博物馆简介
const usBrief = resolve => require(["../views/en-US/brief/brief"], resolve); // 博物馆简介
// 历史沿革
const usHistoryRecord = resolve =>
    require(["../views/en-US/brief/children/historyRecord"], resolve);
// 机构设置
const usSectionSet = resolve =>
    require(["../views/en-US/brief/children/sectionSet"], resolve);
// 馆长致辞
const usCuratorSpeech = resolve =>
    require(["../views/en-US/brief/children/curatorSpeech"], resolve);
// 大事记
const usBigEvents = resolve =>
    require(["../views/en-US/brief/children/bigEvents"], resolve);
// 文创产品
const usWenChuang = resolve =>
    require(["../views/en-US/wenChuang/wenchuang"], resolve); // 文创产品
// 文博快讯
const usWenboNews = resolve =>
    require(["../views/en-US/wenChuang/children/wenboNews"], resolve); // 文博快讯
// 相关公告
const usNotices = resolve =>
    require(["../views/en-US/wenChuang/children/notices"], resolve); // 相关公告

// 快讯公告详情advisoryDetail
const usAdvisoryDetail = resolve =>
    require(["../views/en-US/wenChuang/advisoryDetail"], resolve);
const usTicket = resolve => require(["../views/en-US/ticket/ticket"], resolve); // 票务预约、改扩建工程、党务公开
// 票务
const usAppointment = resolve =>
    require(["../views/en-US/ticket/children/appointment"], resolve); // 票务预约入口
const usNotice = resolve =>
    require(["../views/en-US/ticket/children/children/notice"], resolve); // 预约须知
const usChooseDate = resolve =>
    require(["../views/en-US/ticket/children/children/chooseDate"], resolve); // 选择预约日期
const usPersonalInfo = resolve =>
    require(["../views/en-US/ticket/children/children/personalInfo"], resolve); // 填写个人信息
const usConfirmOrder = resolve =>
    require(["../views/en-US/ticket/children/children/confirmOrder"], resolve); // 确认信息
const usComplete = resolve =>
    require(["../views/en-US/ticket/children/children/complete"], resolve); // 预约完成
// 改扩建工程
const usExtensionPro = resolve =>
    require(["../views/en-US/ticket/children/extensionPro"], resolve);
// 党务政务公开
const usGovernment = resolve =>
    require(["../views/en-US/ticket/children/government"], resolve);
/// ///////////////展览展讯
// 展品详情
const usExhibitionDetail = resolve =>
    require(["../views/en-US/exhibitionMsg/exhibitionDetail"], resolve);
// 展览展讯
const usExhibition = resolve =>
    require(["../views/en-US/exhibition/exhibition"], resolve); // 博物馆简介
// 专题展览
const usSpecialExhibition = resolve =>
    require(["../views/en-US/exhibition/children/specialExhibition"], resolve);
// 展览回眸
const usExhibitionReview = resolve =>
    require(["../views/en-US/exhibition/children/exhibitionReview"], resolve);
// 全景漫游
const usPanoramicRoaming = resolve =>
    require(["../views/en-US/exhibition/children/panoramicRoaming"], resolve);

// 展品详情
const usExhibitsDetail = resolve =>
    require(["../views/en-US/gemEnjoy/exhibitsDetail"], resolve);
// 藏品欣赏
const usGemEnjoy = resolve =>
    require(["../views/en-US/gemEnjoy/gemEnjoy"], resolve);
// 珍品赏析
const usEnjoy = resolve =>
    require(["../views/en-US/gemEnjoy/children/enjoy"], resolve);
// 文物快览
const usQuickLook = resolve =>
    require(["../views/en-US/gemEnjoy/children/quickLook"], resolve);
// 文物征集与捐赠
const usCollect = resolve =>
    require(["../views/en-US/gemEnjoy/children/collect"], resolve);

// 学术研究
const usAcademicResearch = resolve =>
    require(["../views/en-US/academicResearch/academicResearch"], resolve);
// 学术机构
const usAcademicJigou = resolve =>
    require([
        "../views/en-US/academicResearch/children/academicJigou"
    ], resolve);
// 学术期刊
const usAcademicQikan = resolve =>
    require([
        "../views/en-US/academicResearch/children/academicQikan"
    ], resolve);
// 学术讲堂
const usAcademicClassroom = resolve =>
    require([
        "../views/en-US/academicResearch/children/academicClassroom"
    ], resolve);

const usEducationActivities = resolve =>
    require(["../views/en-US/educationActivity/educationActivities"], resolve); // 教育活动
const usVolunteerHome = resolve =>
    require([
        "../views/en-US/educationActivity/children/volunteerHome"
    ], resolve); // 志愿者之家
const usActivityList1 = resolve =>
    require([
        "../views/en-US/educationActivity/children/activityList1"
    ], resolve); // 志愿者之家
const usActivityList2 = resolve =>
    require([
        "../views/en-US/educationActivity/children/activityList2"
    ], resolve); // 志愿者之家
const usActivityList3 = resolve =>
    require([
        "../views/en-US/educationActivity/children/activityList3"
    ], resolve); // 志愿者之家
const usActivityList4 = resolve =>
    require([
        "../views/en-US/educationActivity/children/activityList4"
    ], resolve); // 志愿者之家\
const ushdDetail = resolve =>
    require(["../views/en-US/educationActivity/hdDetail"], resolve); // 志愿者之家
const usvolunteerMien = resolve =>
    require(["../views/en-US/educationActivity/volunteerMien"], resolve); // 志愿者风采
const usactivityDetail = resolve =>
    require(["../views/en-US/educationActivity/activityDetail"], resolve); // 志愿者风采详情

// 科技保护
const usScienceProtect = resolve =>
    require(["../views/en-US/scienceProtect/scienceProtect"], resolve);
// 联合工作站简介
const usScienceIntro = resolve =>
    require(["../views/en-US/scienceProtect/children/scienceIntro"], resolve);
// 保护修复成果
const usScienceAchievement = resolve =>
    require([
        "../views/en-US/scienceProtect/children/scienceAchievement"
    ], resolve);
// 科普知识
const usScienceKnowledge = resolve =>
    require([
        "../views/en-US/scienceProtect/children/scienceKnowledge"
    ], resolve);
// 知识详情knowledgeDetail
const usKnowledgeDetail = resolve =>
    require(["../views/en-US/scienceProtect/knowledgeDetail"], resolve);

// 文创产品
const usWenchuangProduct = resolve =>
    require(["../views/en-US/wenChuangProduct/wenChuangProduct"], resolve);
// 文创产品
const usWcProducts = resolve =>
    require(["../views/en-US/wenChuangProduct/children/wcProducts"], resolve);
// 文创精品
const usWcBoutique = resolve =>
    require(["../views/en-US/wenChuangProduct/children/wcBoutique"], resolve);
// 文创动态
const usWcDynamic = resolve =>
    require(["../views/en-US/wenChuangProduct/children/wcDynamic"], resolve);
// 文创动态详情
const usWcdynamicDetail = resolve =>
    require(["../views/en-US/wenChuangProduct/wcdynamicDetail"], resolve);

// 开闭馆时间
const usOpenTime = resolve =>
    require(["../views/en-US/ticket/children/openTime"], resolve);
/// //////////////////////////////////////////////////////藏文
const zangsIndex = resolve => require(["../views/zangs/index"], resolve);
// 首页底部调查问卷、留言板、法律法规、馆长信箱等
const zangsIndexBtm = resolve =>
    require(["../views/zangs/indexBtm/indexBtm"], resolve);
// 调查问卷
const zangsQuestionnaire = resolve =>
    require(["../views/zangs/indexBtm/children/questionnaire"], resolve);
// 留言板
const zangsMessageBoard = resolve =>
    require(["../views/zangs/indexBtm/children/messageBoard"], resolve);
// 法律法规
const zangsLaws = resolve =>
    require(["../views/zangs/indexBtm/children/laws"], resolve);
// 馆长信箱
const zangsMailbox = resolve =>
    require(["../views/zangs/indexBtm/children/mailbox"], resolve);
// 博物馆简介
const zangsBrief = resolve => require(["../views/zangs/brief/brief"], resolve); // 博物馆简介
// 历史沿革
const zangsHistoryRecord = resolve =>
    require(["../views/zangs/brief/children/historyRecord"], resolve);
// 机构设置
const zangsSectionSet = resolve =>
    require(["../views/zangs/brief/children/sectionSet"], resolve);
// 馆长致辞
const zangsCuratorSpeech = resolve =>
    require(["../views/zangs/brief/children/curatorSpeech"], resolve);
// 大事记
const zangsBigEvents = resolve =>
    require(["../views/zangs/brief/children/bigEvents"], resolve);
// 文创产品
const zangsWenChuang = resolve =>
    require(["../views/zangs/wenChuang/wenchuang"], resolve); // 文创产品
// 文博快讯
const zangsWenboNews = resolve =>
    require(["../views/zangs/wenChuang/children/wenboNews"], resolve); // 文博快讯
// 相关公告
const zangsNotices = resolve =>
    require(["../views/zangs/wenChuang/children/notices"], resolve); // 相关公告

// 快讯公告详情advisoryDetail
const zangsAdvisoryDetail = resolve =>
    require(["../views/zangs/wenChuang/advisoryDetail"], resolve);
const zangsTicket = resolve =>
    require(["../views/zangs/ticket/ticket"], resolve); // 票务预约、改扩建工程、党务公开
// 票务
const zangsAppointment = resolve =>
    require(["../views/zangs/ticket/children/appointment"], resolve); // 票务预约入口
const zangsNotice = resolve =>
    require(["../views/zangs/ticket/children/children/notice"], resolve); // 预约须知
const zangsChooseDate = resolve =>
    require(["../views/zangs/ticket/children/children/chooseDate"], resolve); // 选择预约日期
const zangsPersonalInfo = resolve =>
    require(["../views/zangs/ticket/children/children/personalInfo"], resolve); // 填写个人信息
const zangsConfirmOrder = resolve =>
    require(["../views/zangs/ticket/children/children/confirmOrder"], resolve); // 确认信息
const zangsComplete = resolve =>
    require(["../views/zangs/ticket/children/children/complete"], resolve); // 预约完成
// 改扩建工程
const zangsExtensionPro = resolve =>
    require(["../views/zangs/ticket/children/extensionPro"], resolve);
/// ///////////////展览展讯
// 展品详情
const zangsExhibitionDetail = resolve =>
    require(["../views/zangs/exhibitionMsg/exhibitionDetail"], resolve);
// 展览展讯
const zangsExhibition = resolve =>
    require(["../views/zangs/exhibition/exhibition"], resolve); // 博物馆简介
// 专题展览
const zangsSpecialExhibition = resolve =>
    require(["../views/zangs/exhibition/children/specialExhibition"], resolve);
// 展览回眸
const zangsExhibitionReview = resolve =>
    require(["../views/zangs/exhibition/children/exhibitionReview"], resolve);
// 全景漫游
const zangsPanoramicRoaming = resolve =>
    require(["../views/zangs/exhibition/children/panoramicRoaming"], resolve);

// 展品详情
const zangsExhibitsDetail = resolve =>
    require(["../views/zangs/gemEnjoy/exhibitsDetail"], resolve);
// 藏品欣赏
const zangsGemEnjoy = resolve =>
    require(["../views/zangs/gemEnjoy/gemEnjoy"], resolve);
// 珍品赏析
const zangsEnjoy = resolve =>
    require(["../views/zangs/gemEnjoy/children/enjoy"], resolve);
// 文物快览
const zangsQuickLook = resolve =>
    require(["../views/zangs/gemEnjoy/children/quickLook"], resolve);
// 文物征集与捐赠
const zangsCollect = resolve =>
    require(["../views/zangs/gemEnjoy/children/collect"], resolve);

// 学术研究
const zangsAcademicResearch = resolve =>
    require(["../views/zangs/academicResearch/academicResearch"], resolve);
// 学术机构
const zangsAcademicJigou = resolve =>
    require([
        "../views/zangs/academicResearch/children/academicJigou"
    ], resolve);
// 学术期刊
const zangsAcademicQikan = resolve =>
    require([
        "../views/zangs/academicResearch/children/academicQikan"
    ], resolve);
// 学术讲堂
const zangsAcademicClassroom = resolve =>
    require([
        "../views/zangs/academicResearch/children/academicClassroom"
    ], resolve);

const zangsEducationActivities = resolve =>
    require(["../views/zangs/educationActivity/educationActivities"], resolve); // 教育活动
const zangsVolunteerHome = resolve =>
    require([
        "../views/zangs/educationActivity/children/volunteerHome"
    ], resolve); // 志愿者之家
const zangsActivityList1 = resolve =>
    require([
        "../views/zangs/educationActivity/children/activityList1"
    ], resolve); // 志愿者之家
const zangsActivityList2 = resolve =>
    require([
        "../views/zangs/educationActivity/children/activityList2"
    ], resolve); // 志愿者之家
const zangsActivityList3 = resolve =>
    require([
        "../views/zangs/educationActivity/children/activityList3"
    ], resolve); // 志愿者之家
const zangsActivityList4 = resolve =>
    require([
        "../views/zangs/educationActivity/children/activityList4"
    ], resolve); // 志愿者之家\
const zangshdDetail = resolve =>
    require(["../views/zangs/educationActivity/hdDetail"], resolve); // 志愿者之家
const zangsvolunteerMien = resolve =>
    require(["../views/zangs/educationActivity/volunteerMien"], resolve); // 志愿者风采
const zangsactivityDetail = resolve =>
    require(["../views/zangs/educationActivity/activityDetail"], resolve); // 志愿者风采详情

// 科技保护
const zangsScienceProtect = resolve =>
    require(["../views/zangs/scienceProtect/scienceProtect"], resolve);
// 联合工作站简介
const zangsScienceIntro = resolve =>
    require(["../views/zangs/scienceProtect/children/scienceIntro"], resolve);
// 保护修复成果
const zangsScienceAchievement = resolve =>
    require([
        "../views/zangs/scienceProtect/children/scienceAchievement"
    ], resolve);
// 科普知识
const zangsScienceKnowledge = resolve =>
    require([
        "../views/zangs/scienceProtect/children/scienceKnowledge"
    ], resolve);
// 知识详情knowledgeDetail
const zangsKnowledgeDetail = resolve =>
    require(["../views/zangs/scienceProtect/knowledgeDetail"], resolve);

// 文创产品
const zangsWenchuangProduct = resolve =>
    require(["../views/zangs/wenChuangProduct/wenChuangProduct"], resolve);
// 文创产品
const zangsWcProducts = resolve =>
    require(["../views/zangs/wenChuangProduct/children/wcProducts"], resolve);
// 文创精品
const zangsWcBoutique = resolve =>
    require(["../views/zangs/wenChuangProduct/children/wcBoutique"], resolve);
// 文创动态
const zangsWcDynamic = resolve =>
    require(["../views/zangs/wenChuangProduct/children/wcDynamic"], resolve);
// 文创动态详情
const zangsWcdynamicDetail = resolve =>
    require(["../views/zangs/wenChuangProduct/wcdynamicDetail"], resolve);

// 开闭馆时间
const zangsOpenTime = resolve =>
    require(["../views/zangs/ticket/children/openTime"], resolve);
// 党务政务公开
const zangsGovernment = resolve =>
    require(["../views/zangs/ticket/children/government"], resolve);
// 用户中心(不区分中、英、藏，所有的个人中心都显示中文)
const user = resolve => require(["../views/zh-CN/user/index.vue"], resolve); // 科普知识
// 用户收藏列表
const collectList = resolve =>
    require(["../views/zh-CN/user/collect-list.vue"], resolve);

const yx_entry = resolve =>
    require(["../views/zh-CN/yanxue/entry.vue"], resolve);
export default [
    {
        path: "/",
        redirect: "/zh-CN/startPage"
    },
    {
        path: "/zh-CN/searchResult",
        component: searchResult,
        meta: {
            title: "搜索结果"
        }
    },
    {
        path: "/en-US/searchResult",
        component: usSearchResult,
        meta: {
            title: "Search"
        }
    },
    {
        path: "/zangs/searchResult",
        component: zangsSearchResult,
        meta: {
            title: "འཚོལ་བཤེར།"
        }
    },
    {
        path: "/zh-CN/index",
        component: Index,
        meta: {
            title: "首页",
            keepAlive: false
        }
    },

    {
        path: "/zh-CN/publicService",
        component: resolve =>
            require([
                "../views/zh-CN/publicService/publicService.vue"
            ], resolve),
        meta: {
            title: "公众服务",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/museumFriend",
        component: resolve =>
            require(["../views/zh-CN/museumFriend/museumFriend.vue"], resolve),
        meta: {
            title: "博物馆之友",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/educationActivity", // 教育活动主页
        component: educationActivity,
        meta: {
            title: "教育活动",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/educationActivity/activityList1", // 活动列表
        component: activityList1,
        meta: {
            title: "最新活动",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/educationActivity/activityList2", // 活动列表
        component: activityList2,
        meta: {
            title: "活动专题",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/educationActivity/activityList3", // 活动列表
        component: activityList3,
        meta: {
            title: "活动回顾",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/educationActivity/activityList4", // 活动列表
        component: activityList4,
        meta: {
            title: "少儿专区",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/educationActivity/volunteerHome", // 志愿者之家
        component: volunteerHome,
        meta: {
            title: "志愿者之家",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/educationActivity/volunteerMien", // 志愿者风采
        component: volunteerMien,
        meta: {
            title: "志愿者风采",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/educationActivity/activityDetail", // 志愿者风采详情
        component: activityDetail,
        meta: {
            title: "详情",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/educationActivity/hdDetail",
        component: hdDetail,
        meta: {
            title: "详情",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/startPage",
        component: startPage,
        meta: {
            title: "西藏博物馆"
        }
    },
    {
        path: "/zh-CN/exhibitionMsg", // 展览展讯
        component: exhibitionMsg,
        meta: {
            title: "展览展讯",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/allQuanjing", // 全景漫游-全部
        component: allQuanjing,
        meta: {
            title: "全景漫游"
        }
    },
    {
        path: "/zh-CN/allZhuanti", // 专题展览-全部
        component: allZhuanti,
        meta: {
            title: "专题展览",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/exhibitionReview",
        component: exhibitionReview,
        meta: {
            title: "特展回眸",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/exhibitionDetail", // 展品详情
        component: exhibitionDetail,
        meta: {
            title: "详情",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/knowledgeDetail", // 知识详情
        component: knowledgeDetail,
        meta: {
            title: "详情",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/scienceProtect",
        component: scienceProtect,
        redirect: "/zh-CN/scienceProtect/scienceIntro",
        children: [
            {
                path: "scienceIntro", // 联合工作站简介
                component: scienceIntro,
                meta: {
                    title: "联合工作站简介",
                    keepAlive: true
                }
            },
            {
                path: "scienceAchievement", // 保护修复成果
                component: scienceAchievement,
                meta: {
                    title: "保护修复成果",
                    keepAlive: true
                }
            },
            {
                path: "scienceKnowledge", // 科普知识
                component: scienceKnowledge,
                meta: {
                    title: "科普知识",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zh-CN/academicResearch",
        component: academicResearch,
        redirect: "/zh-CN/academicResearch/academicJigou",
        children: [
            {
                path: "academicJigou", // 学术机构
                component: academicJigou,
                meta: {
                    title: "学术机构",
                    keepAlive: false
                }
            },
            {
                path: "academicQikan", // 学术期刊
                component: academicQikan,
                meta: {
                    title: "学术期刊",
                    keepAlive: true
                }
            },
            {
                path: "academicClassroom", // 学术讲堂
                name: "myacademicClassroom",
                component: academicClassroom,
                meta: {
                    title: "学术讲堂",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zh-CN/academicResearch/academicClassroom/detail/:id",
        name: "academicClassroomDetail",
        component: resolve =>
            require([
                "../views/zh-CN/academicResearch/children/academicDetail.vue"
            ], resolve),
        meta: {
            title: "学术讲堂",
            keepAlive: true
        },
        props: true
    },
    {
        path: "/zh-CN/indexBtm",
        component: indexBtm,
        redirect: "/zh-CN/indexBtm/questionnaire",
        children: [
            {
                path: "questionnaire", // 调查问卷
                component: questionnaire,
                meta: {
                    title: "调查问卷",
                    keepAlive: false
                }
            },
            {
                path: "messageBoard", // 留言板
                component: messageBoard,
                meta: {
                    title: "留言板",
                    keepAlive: false
                }
            },
            {
                path: "laws", // 反律法规
                component: laws,
                meta: {
                    title: "政策法规",
                    keepAlive: true
                }
            },
            {
                path: "mailbox", // 馆长信箱
                component: mailbox,
                meta: {
                    title: "馆长信箱",
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: "/zh-CN/advisoryDetail",
        component: advisoryDetail,
        meta: {
            title: "详情",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/wcdynamicDetail",
        component: wcdynamicDetail,
        meta: {
            title: "详情",
            keepAlive: false
        }
    },
    {
        path: "/zh-CN/wenchuangProduct",
        component: wenchuangProduct,
        children: [
            {
                path: "wcBoutique", // 文创精品
                component: wcBoutique,
                query: {
                    navIndex: 4
                },
                meta: {
                    title: "文创精品",
                    keepAlive: true
                }
            },
            {
                path: "wcProducts", // 文创产品
                component: wcProducts,
                query: {
                    navIndex: 4
                },
                meta: {
                    title: "文创产品",
                    keepAlive: true
                }
            },
            {
                path: "wcDynamic", // 文创动态
                component: wcDynamic,
                query: {
                    navIndex: 4
                },
                meta: {
                    title: "文创动态",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zh-CN/exhibitsDetail",
        component: exhibitsDetail,
        meta: {
            title: "详情",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/Solicitation",
        component: solicitation,
        meta: {
            title: "登记藏品",
            keepAlive: true
        }
    },
    {
        path: "/zh-CN/gemEnjoy", // 藏品欣赏
        component: gemEnjoy,
        redirect: "/zh-CN/gemEnjoy/enjoy",
        children: [
            {
                path: "enjoy", // 珍品赏析
                component: enjoy,
                meta: {
                    title: "珍品赏析",
                    keepAlive: true
                }
            },
            {
                path: "quickLook", // 文物快览
                component: quickLook,
                meta: {
                    title: "文物快览",
                    keepAlive: true
                }
            },
            {
                path: "collect", // 文物征集与捐赠
                component: collect,
                meta: {
                    title: "文物征集与捐赠",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zh-CN/wenChuang",
        component: wenChuang,
        redirect: "/zh-CN/wenChuang/wenboNews",
        children: [
            {
                path: "wenboNews", // 文博快讯
                component: wenboNews,
                meta: {
                    title: "文博快讯",
                    keepAlive: true
                }
            },
            {
                path: "notices", // 文博快讯
                component: notices,
                meta: {
                    title: "相关公告",
                    keepAlive: true
                }
            },
            ,
            {
                path: "policies", // 政策法规
                component: policies,
                meta: {
                    title: "政策法规",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zh-CN/brief",
        component: brief,
        redirect: "/zh-CN/brief/historyRecord",
        children: [
            {
                path: "historyRecord", // 历史沿革
                component: historyRecord,
                meta: {
                    title: "历史沿革",
                    keepAlive: false
                }
            },
            {
                path: "sectionSet", // 机构设置
                component: sectionSet,
                meta: {
                    title: "机构设置",
                    keepAlive: false
                }
            },
            {
                path: "curatorSpeech", // 馆长致辞
                component: curatorSpeech,
                meta: {
                    title: "馆长致辞",
                    keepAlive: false
                }
            },
            {
                path: "bigEvents", // 大事记
                component: bigEvents,
                meta: {
                    title: "大事记",
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: "/zh-CN/ticket",
        redirect: "/zh-CN/ticket/appointment",
        component: ticket,
        children: [
            {
                // 预约
                path: "appointment",
                redirect: "/zh-CN/ticket/appointment/notice",
                component: appointment,
                meta: {
                    title: "票务预约",
                    keepAlive: false
                },
                children: [
                    {
                        path: "notice", // 选择日期
                        component: notice,
                        meta: {
                            title: "网上预约",
                            keepAlive: true
                        }
                    },
                    {
                        path: "chooseDate", // 选择日期
                        component: chooseDate,
                        meta: {
                            title: "网上预约",
                            keepAlive: false
                        }
                    },
                    {
                        path: "personalInfo", // 填写个人信息
                        component: personalInfo,
                        meta: {
                            title: "网上预约",
                            keepAlive: false
                        }
                    },
                    {
                        path: "confirmOrder", // 确认订单
                        component: confirmOrder,
                        meta: {
                            title: "网上预约",
                            keepAlive: false
                        }
                    },
                    {
                        path: "complete", // 预约完成
                        component: complete,
                        meta: {
                            title: "网上预约",
                            keepAlive: false
                        }
                    }
                ]
            },
            {
                path: "extensionPro", // 改扩建工程
                component: extensionPro,
                meta: {
                    title: "改扩建工程",
                    keepAlive: true
                }
            },
            {
                path: "government", // 党务政务公开
                component: government,
                meta: {
                    title: "党务政务公开",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zh-CN/yanxue",
        name: "yanxue",
        component: yx_entry
    },
    /// ////////////////////////////英藏版
    {
        path: "/en-US/index", // 英藏版首页
        component: usIndex,
        meta: {
            title: "Home Page"
        }
    },
    {
        path: "/en-US/educationActivity/volunteerMien",
        component: usvolunteerMien,
        meta: {
            title: "Volunteers"
        }
    },
    {
        path: "/en-US/educationActivity/activityDetail", // 志愿者风采详情
        component: usactivityDetail,
        meta: {
            title: "Details",
            keepAlive: true
        }
    },
    {
        path: "/en-US/educationActivity", // 教育活动
        component: usEducationActivities,
        redirect: "/en-US/educationActivity/activityList1?typeVal=1",
        children: [
            {
                path: "/en-US/educationActivity/activityList3",
                component: usActivityList3,
                meta: {
                    title: "Review of Activities",
                    keepAlive: true
                }
            },
            {
                path: "/en-US/educationActivity/volunteerHome", // 志愿者之家
                component: usVolunteerHome,
                meta: {
                    title: "Home of Volunteers",
                    keepAlive: true
                }
            },
            {
                path: "/en-US/educationActivity/activityList1",
                component: usActivityList1,
                meta: {
                    title: "Latest Activities",
                    keepAlive: true
                }
            },
            {
                path: "/en-US/educationActivity/activityList2",
                component: usActivityList2,
                meta: {
                    title: "Special Activities",
                    keepAlive: true
                }
            },
            {
                path: "/en-US/educationActivity/activityList4",
                component: usActivityList4,
                meta: {
                    title: "Review of Activities",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/en-US/educationActivity/hdDetail",
        component: ushdDetail,
        meta: {
            title: "Details",
            keepAlive: true
        }
    },
    {
        path: "/en-US/academicResearch",
        component: usAcademicResearch,
        redirect: "/en-US/academicResearch/academicJigou",
        children: [
            {
                path: "academicJigou", // 学术机构
                component: usAcademicJigou,
                meta: {
                    title: "Academic Institutions",
                    keepAlive: false
                }
            },
            {
                path: "academicQikan", // 学术期刊
                component: usAcademicQikan,
                meta: {
                    title: "Academic Periodicals",
                    keepAlive: true
                }
            },
            {
                path: "academicClassroom", // 学术讲堂
                component: usAcademicClassroom,
                meta: {
                    title: "Academic Classroom",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/en-US/exhibitsDetail",
        component: usExhibitsDetail,
        meta: {
            title: "Details",
            keepAlive: true
        }
    },
    {
        path: "/en-US/gemEnjoy", // 藏品欣赏
        component: usGemEnjoy,
        redirect: "/en-US/gemEnjoy/enjoy",
        children: [
            {
                path: "enjoy", // 珍品赏析
                component: usEnjoy,
                meta: {
                    title: "Treasure Appreciation",
                    keepAlive: true
                }
            },
            {
                path: "quickLook", // 文物快览
                component: usQuickLook,
                meta: {
                    title: "Quick View of Cultural Relics",
                    keepAlive: true
                }
            },
            {
                path: "collect", // 文物征集与捐赠
                component: usCollect,
                meta: {
                    title: "Collection and Donation of Cultural Relics",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/en-US/exhibitionDetail",
        component: usExhibitionDetail,
        meta: {
            title: "Details",
            keepAlive: true
        }
    },
    {
        path: "/en-US/exhibitionMsg",
        component: usExhibition,
        redirect: { path: "/en-US/allZhuanti" },
        children: [
            {
                path: "/en-US/allZhuanti", // 专题展览
                component: usSpecialExhibition,
                meta: {
                    title: "Exhibitions on Special Topics",
                    keepAlive: true
                }
            },
            {
                path: "/en-US/exhibitionReview", // 展览回眸
                component: usExhibitionReview,
                meta: {
                    title: "Review of Special Exhibitions",
                    keepAlive: true
                }
            },
            {
                path: "/en-US/allQuanjing", // 全景漫游
                component: usPanoramicRoaming,
                meta: {
                    title: "Panoramic Wandering",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/en-US/indexBtm",
        component: usIndexBtm,
        redirect: "/en-US/indexBtm/questionnaire",
        children: [
            {
                path: "questionnaire", // 调查问卷
                component: usQuestionnaire,
                meta: {
                    title: "Questionnaire",
                    keepAlive: false
                }
            },
            {
                path: "messageBoard", // 留言板
                component: usMessageBoard,
                meta: {
                    title: "Message board",
                    keepAlive: false
                }
            },
            {
                path: "laws", // 反律法规
                component: usLaws,
                meta: {
                    title: "Policies and regulations",
                    keepAlive: true
                }
            },
            {
                path: "mailbox", // 馆长信箱
                component: usMailbox,
                meta: {
                    title: "Curator's mailbox",
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: "/en-US/brief",
        component: usBrief,
        redirect: "/en-US/brief/historyRecord",
        children: [
            {
                path: "historyRecord", // 历史沿革
                component: usHistoryRecord,
                meta: {
                    title: "Historical Development",
                    keepAlive: false
                }
            },
            {
                path: "sectionSet", // 机构设置
                component: usSectionSet,
                meta: {
                    title: "Organization Structuring",
                    keepAlive: false
                }
            },
            {
                path: "curatorSpeech", // 馆长致辞
                component: usCuratorSpeech,
                meta: {
                    title: "Curator’s Words",
                    keepAlive: false
                }
            },
            {
                path: "bigEvents", // 大事记
                component: usBigEvents,
                meta: {
                    title: "Chronicle of Events",
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: "/en-US/advisoryDetail",
        component: usAdvisoryDetail,
        meta: {
            title: "Details",
            keepAlive: true
        }
    },
    {
        path: "/en-US/wenChuang",
        component: usWenChuang,
        children: [
            {
                path: "wenboNews", // 文博快讯
                component: usWenboNews,
                meta: {
                    title: "Wenbo News",
                    keepAlive: true
                }
            },
            {
                path: "notices", // 文博快讯
                component: usNotices,
                meta: {
                    title: "Related announcement",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/en-US/ticket",
        redirect: "/en-US/ticket/appointment",
        component: usTicket,
        children: [
            {
                // 预约
                path: "appointment",
                redirect: "/en-US/ticket/appointment/notice",
                component: usAppointment,
                meta: {
                    title: "Ticket reservation",
                    keepAlive: false
                },
                children: [
                    {
                        path: "notice", // 选择日期
                        component: usNotice,
                        meta: {
                            title: "Ticket reservation",
                            keepAlive: true
                        }
                    },
                    {
                        path: "chooseDate", // 选择日期
                        component: usChooseDate,
                        meta: {
                            title: "Ticket reservation",
                            keepAlive: false
                        }
                    },
                    {
                        path: "personalInfo", // 填写个人信息
                        component: usPersonalInfo,
                        meta: {
                            title: "Ticket reservation",
                            keepAlive: false
                        }
                    },
                    {
                        path: "confirmOrder", // 确认订单
                        component: usConfirmOrder,
                        meta: {
                            title: "Ticket reservation",
                            keepAlive: false
                        }
                    },
                    {
                        path: "complete", // 预约完成
                        component: usComplete,
                        meta: {
                            title: "Ticket reservation",
                            keepAlive: false
                        }
                    }
                ]
            },
            {
                path: "extensionPro", // 改扩建工程
                component: usExtensionPro,
                meta: {
                    title: "Reconstruction and expansion project",
                    keepAlive: true
                }
            },
            {
                path: "openTime",
                component: usOpenTime,
                meta: {
                    title: "Opening and closing time",
                    keepAlive: true
                }
            },
            {
                path: "government",
                component: usGovernment,
                meta: {
                    title: "Making Party and Administrative Affairs Public",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/en-US/knowledgeDetail",
        component: usKnowledgeDetail,
        meta: {
            title: "Details",
            keepAlive: false
        }
    },
    {
        path: "/en-US/scienceProtect",
        component: usScienceProtect,
        redirect: "/en-US/scienceProtect/scienceIntro",
        children: [
            {
                path: "scienceIntro", // 联合工作站简介
                component: usScienceIntro,
                meta: {
                    title: "Introduction to Contact Workstation",
                    keepAlive: false
                }
            },
            {
                path: "scienceAchievement", // 保护修复成果
                component: usScienceAchievement,
                meta: {
                    title: "Achievements of Protection and Restoration",
                    keepAlive: false
                }
            },
            {
                path: "scienceKnowledge", // 科普知识
                component: usScienceKnowledge,
                meta: {
                    title: "Science Popularization Knowledge",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/en-US/wcdynamicDetail",
        component: usWcdynamicDetail,
        meta: {
            title: "Details",
            keepAlive: true
        }
    },
    {
        path: "/en-US/wenchuangProduct",
        component: usWenchuangProduct,
        redirect: "/en-US/wenchuangProduct/wcProducts",
        children: [
            {
                path: "wcProducts", // 文创产品
                component: usWcProducts,
                meta: {
                    title: "Souvenirs",
                    keepAlive: true
                }
            },
            {
                path: "wcBoutique", // 文创精品
                component: usWcBoutique,
                meta: {
                    title: "Exquisite Souvenirs",
                    keepAlive: true
                }
            },
            {
                path: "wcDynamic", // 文创动态
                component: usWcDynamic,
                meta: {
                    title: "News about Souvenirs",
                    keepAlive: true
                }
            }
        ]
    }, /// ///////////////////////////////////////////////藏文
    {
        path: "/zangs/index", // 英藏版首页
        component: zangsIndex,
        meta: {
            title: "མདུན་ངོས།"
        }
    },
    {
        path: "/zangs/educationActivity/volunteerMien",
        component: zangsvolunteerMien,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/zangs/educationActivity/activityDetail", // 志愿者风采详情
        component: zangsactivityDetail,
        meta: {
            title: "གནས་ཚུལ་ཞིབ་ཕྲ།",
            keepAlive: true
        }
    },
    {
        path: "/zangs/educationActivity", // 教育活动
        component: zangsEducationActivities,
        redirect: "/zangs/educationActivity/activityList1?typeVal=1",
        children: [
            {
                path: "/zangs/educationActivity/volunteerHome", // 志愿者之家
                component: zangsVolunteerHome,
                meta: {
                    title: "དང་བླངས་པའི་ཁྱིམ་གཞི།",
                    keepAlive: true
                }
            },
            {
                path: "/zangs/educationActivity/activityList1",
                component: zangsActivityList1,
                meta: {
                    title: "བྱེད་སྒོ་གསར་ཤོས།",
                    keepAlive: true
                }
            },
            {
                path: "/zangs/educationActivity/activityList2",
                component: zangsActivityList2,
                meta: {
                    title: "ཆེད་སྒྲིག་བྱེད་སྒོ།",
                    keepAlive: true
                }
            },
            {
                path: "/zangs/educationActivity/activityList3",
                component: zangsActivityList3,
                meta: {
                    title: "བྱེད་སྒོར་ཕྱིར་རྟོག",
                    keepAlive: true
                }
            },
            {
                path: "/zangs/educationActivity/activityList4",
                component: zangsActivityList4,
                meta: {
                    title: "ལོ་ཆུང་བྱིས་པའི་ཆེད་ཁུལ།",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zangs/educationActivity/hdDetail",
        component: zangshdDetail,
        meta: {
            title: "གནས་ཚུལ་ཞིབ་ཕྲ།",
            keepAlive: true
        }
    },
    {
        path: "/zangs/academicResearch",
        component: zangsAcademicResearch,
        redirect: "/zangs/academicResearch/academicJigou",
        children: [
            {
                path: "academicJigou", // 学术机构
                component: zangsAcademicJigou,
                meta: {
                    title: "རིག་གཞུང་སྡེ་ཁག",
                    keepAlive: true
                }
            },
            {
                path: "academicQikan", // 学术期刊
                component: zangsAcademicQikan,
                meta: {
                    title: "རིག་གཞུང་དུས་དེབ།",
                    keepAlive: true
                }
            },
            {
                path: "academicClassroom", // 学术讲堂
                component: zangsAcademicClassroom,
                meta: {
                    title: "རིག་གཞུང་ཁྲིད་སྟེགས།",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zangs/exhibitsDetail",
        component: zangsExhibitsDetail,
        meta: {
            title: "གནས་ཚུལ་ཞིབ་ཕྲ།",
            keepAlive: false
        }
    },
    {
        path: "/zangs/gemEnjoy", // 藏品欣赏
        component: zangsGemEnjoy,
        redirect: "/zangs/gemEnjoy/enjoy",
        children: [
            {
                path: "enjoy", // 珍品赏析
                component: zangsEnjoy,
                meta: {
                    title: "རྟེན་རྫས་རྩ་ཆེན་ཉམས་ཞིབ།",
                    keepAlive: true
                }
            },
            {
                path: "quickLook", // 文物快览
                component: zangsQuickLook,
                meta: {
                    title: "རིག་དངོས་མྱུར་གཟིགས།",
                    keepAlive: true
                }
            },
            {
                path: "collect", // 文物征集与捐赠
                component: zangsCollect,
                meta: {
                    title: "རིག་དངོས་བསྡུ་རུབ་དང་སྐྱེས་འབུལ།",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zangs/exhibitionDetail",
        component: zangsExhibitionDetail,
        meta: {
            title: "གནས་ཚུལ་ཞིབ་ཕྲ།",
            keepAlive: false
        }
    },
    {
        path: "/zangs/exhibitionMsg",
        component: zangsExhibition,
        redirect: { path: "/zangs/allZhuanti" },
        children: [
            {
                path: "/zangs/allZhuanti", // 专题展览
                component: zangsSpecialExhibition,
                meta: {
                    title: "ཆེད་སྒྲིག་བཤམས་སྟོན།",
                    keepAlive: true
                }
            },
            {
                path: "/zangs/exhibitionReview", // 展览回眸
                component: zangsExhibitionReview,
                meta: {
                    title: "ཆེད་འགྲེམས་ཕྱིར་གཟིགས།",
                    keepAlive: true
                }
            },
            {
                path: "/zangs/allQuanjing", // 全景漫游
                component: zangsPanoramicRoaming,
                meta: {
                    title: "ལྗོངས་ཡོངས་འགྲུལ་བཞུད།",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zangs/indexBtm",
        component: zangsIndexBtm,
        redirect: "/zangs/indexBtm/questionnaire",
        children: [
            {
                path: "questionnaire", // 调查问卷
                component: zangsQuestionnaire,
                meta: {
                    title: "བརྟག་དཔྱད་འདྲི་གཞི།",
                    keepAlive: false
                }
            },
            {
                path: "messageBoard", // 留言板
                component: zangsMessageBoard,
                meta: {
                    title: "སྐད་འཇོག་ས།",
                    keepAlive: false
                }
            },
            {
                path: "laws", // 反律法规
                component: zangsLaws,
                meta: {
                    title: "ཁྲིམས་ལུགས་ཁྲིམས་སྲོལ།",
                    keepAlive: true
                }
            },
            {
                path: "mailbox", // 馆长信箱
                component: zangsMailbox,
                meta: {
                    title: "མཛོད་ཁང་གི་འགོ་གཙོའི་ཡིག་སྒམ།",
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: "/zangs/brief",
        component: zangsBrief,
        redirect: "/zangs/brief/historyRecord",
        children: [
            {
                path: "historyRecord", // 历史沿革
                component: zangsHistoryRecord,
                meta: {
                    title: "ལོ་རྒྱུས་འཕེལ་རིམ།",
                    keepAlive: false
                }
            },
            {
                path: "sectionSet", // 机构设置
                component: zangsSectionSet,
                meta: {
                    title: "ལས་ཁུངས་བཀོད་སྒྲིག",
                    keepAlive: false
                }
            },
            {
                path: "curatorSpeech", // 馆长致辞
                component: zangsCuratorSpeech,
                meta: {
                    title: "མཛོད་ཁང་གི་འགོ་གཙོའི་ཞུ་ཚིག",
                    keepAlive: false
                }
            },
            {
                path: "bigEvents", // 大事记
                component: zangsBigEvents,
                meta: {
                    title: "དོན་ཆེན་ཟིན་བཀོད།",
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: "/zangs/advisoryDetail",
        component: zangsAdvisoryDetail,
        meta: {
            title: "གནས་ཚུལ་ཞིབ་ཕྲ།",
            keepAlive: true
        }
    },
    {
        path: "/zangs/wenChuang",
        component: zangsWenChuang,
        redirect: "/zangs/wenChuang/wenboNews",
        children: [
            {
                path: "wenboNews", // 文博快讯
                component: zangsWenboNews,
                meta: {
                    title: "རྟེན་རྫས་བཤམས་མཛོད་མྱུར་འཕྲིན།",
                    keepAlive: true
                }
            },
            {
                path: "notices", // 文博快讯
                component: zangsNotices,
                meta: {
                    title: "འབྲེལ་ཡོད་གསལ་བརྡ།",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zangs/ticket",
        redirect: "/zangs/ticket/appointment",
        component: zangsTicket,
        children: [
            {
                // 预约
                path: "appointment",
                redirect: "/zangs/ticket/appointment/notice",
                component: zangsAppointment,
                meta: {
                    title: "སྤ་སེ་སྔོན་མངགས།",
                    keepAlive: false
                },
                children: [
                    {
                        path: "notice", // 选择日期
                        component: zangsNotice,
                        meta: {
                            title: "སྔོན་ལ་དུས་ཆད་འཇོག་པ།",
                            keepAlive: true
                        }
                    },
                    {
                        path: "chooseDate", // 选择日期
                        component: zangsChooseDate,
                        meta: {
                            title: "སྔོན་ལ་དུས་ཆད་འཇོག་པ།",
                            keepAlive: false
                        }
                    },
                    {
                        path: "personalInfo", // 填写个人信息
                        component: zangsPersonalInfo,
                        meta: {
                            title: "སྔོན་ལ་དུས་ཆད་འཇོག་པ།",
                            keepAlive: false
                        }
                    },
                    {
                        path: "confirmOrder", // 确认订单
                        component: zangsConfirmOrder,
                        meta: {
                            title: "སྔོན་ལ་དུས་ཆད་འཇོག་པ།",
                            keepAlive: false
                        }
                    },
                    {
                        path: "complete", // 预约完成
                        component: zangsComplete,
                        meta: {
                            title: "སྔོན་ལ་དུས་ཆད་འཇོག་པ།",
                            keepAlive: false
                        }
                    }
                ]
            },
            {
                path: "extensionPro", // 改扩建工程
                component: zangsExtensionPro,
                meta: {
                    title: "བསྐྱར་སྐྲུན་རྒྱས་སྐྲུན་གྱི་ལས་གཞི།",
                    keepAlive: true
                }
            },
            {
                path: "openTime",
                component: zangsOpenTime,
                meta: {
                    title: "སྒོ་ཕྱེ་བ་དང་རྒྱག་པའི་དུས་ཚོད།",
                    keepAlive: true
                }
            },
            {
                path: "government",
                component: zangsGovernment,
                meta: {
                    title: "ཏང་དོན་དང་སྲིད་དོན་ཡོངས་བསྒྲགས་བྱེད་པ།",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zangs/knowledgeDetail",
        component: zangsKnowledgeDetail,
        meta: {
            title: "གནས་ཚུལ་ཞིབ་ཕྲ།",
            keepAlive: true
        }
    },
    {
        path: "/zangs/scienceProtect",
        component: zangsScienceProtect,
        redirect: "/zangs/scienceProtect/scienceIntro",
        children: [
            {
                path: "scienceIntro", // 联合工作站简介
                component: zangsScienceIntro,
                meta: {
                    title: "མཉམ་འབྲེལ་ལས་དོན་ས་ཚིགས་ཀྱི་ངོ་སྤྲོད་མདོར་བསྡུས།",
                    keepAlive: false
                }
            },
            {
                path: "scienceAchievement", // 保护修复成果
                component: zangsScienceAchievement,
                meta: {
                    title: "སྲུང་སྐྱོབ་ཞིག་གསོའི་འབྲས་བུ།",
                    keepAlive: false
                }
            },
            {
                path: "scienceKnowledge", // 科普知识
                component: zangsScienceKnowledge,
                meta: {
                    title: "ཚན་རིག་ཁྱབ་གདལ་ཤེས་བྱ།",
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: "/zangs/wcdynamicDetail",
        component: zangsWcdynamicDetail,
        meta: {
            title: "གནས་ཚུལ་ཞིབ་ཕྲ།",
            keepAlive: true
        }
    },
    {
        path: "/zangs/wenchuangProduct",
        component: zangsWenchuangProduct,
        redirect: "/zangs/wenchuangProduct/wcProducts",
        children: [
            {
                path: "wcProducts", // 文创产品
                component: zangsWcProducts,
                meta: {
                    title: "རིག་གཏོད་ཐོན་རྫས།",
                    keepAlive: true
                }
            },
            {
                path: "wcBoutique", // 文创精品
                component: zangsWcBoutique,
                meta: {
                    title: "རིག་གཏོད་སྤུས་ལེགས་ཐོན་རྫས།",
                    keepAlive: true
                }
            },
            {
                path: "wcDynamic", // 文创动态
                component: zangsWcDynamic,
                meta: {
                    title: "རིག་གཏོད་གནས་སྟངས།",
                    keepAlive: true
                }
            }
        ]
    },
    // 用户中心
    {
        path: "/zh-CN/user",
        name: "user",
        component: user,
        meta: {
            keepAlive: false
        }
    },
    // 收藏列表
    {
        path: "/zh-CN/user/collectList",
        name: "collectList",
        component: collectList,
        meta: {
            keepAlive: false
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/index.js